module.exports = __webpack_public_path__ + "static/media/icon-firearm.7e91c37d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/icon-firearm.svg
// module id = 1004
// module chunks = 0